//*react- recursos

//css
import "./style.css";

//*interfaces
interface PropsTC {
  estado: any;
}

//*componente
export default function GeneraSemaforo(props: PropsTC) {
  //*constantes y variables
  let estado = props.estado;

  //*vista
  return (
    <>
      {estado === "r" ? (
        <>
          <div className="espacio">
            <h1>Rojo </h1>
            <div className="rojo"></div>
            <div className="amarilloInactivo"></div>
            <div className="verdeInactivo"></div>
          </div>
        </>
      ) : (
        ""
      )}

      {estado === "v" ? (
        <>
          <div className="espacio">
            <h1>Verde </h1>

            <div className="rojoInactivo"></div>
            <div className="amarilloInactivo"></div>
            <div className="verde"></div>
          </div>
        </>
      ) : (
        ""
      )}

      {estado === "a" ? (
        <>
          <div className="espacio">
            <h1>Amarillo </h1>
            <div className="rojoInactivo"></div>
            <div className="amarillo"></div>
            <div className="verdeInactivo"></div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
